// extracted by mini-css-extract-plugin
export default {"reviewUsers":"f263d798cfbb","center":"cf8061347c2e"};